import React from "react";
import { Alert } from "../../../components/ui/alert";
import { useGetAssemblyQuery } from "../api/playbookApi";
import { AssemblyType } from "../types/assembly-model";
import { useAssemblyContext } from "../context/AssemblyContext";

const getTypeString = (type?: AssemblyType) => {
  switch (type) {
    case AssemblyType.DocxPerDocument:
      return "Per-document";
    case AssemblyType.DocxFlowWide:
      return "Flow-wide";
    default:
      return "";
  }
};

/** Which assembly this document is, and where it came from, in two lines under the mode row. */
const AssemblyDetails = () => {
  const ctx = useAssemblyContext();
  const { data: assembly, error } = useGetAssemblyQuery(ctx);
  const type = getTypeString(assembly?.assemblyType);

  return (
    <div className="border-b border-border px-3.5 pt-3 pb-2.5">
      <h2 className="truncate text-subtitle1 text-strong">{assembly?.name ?? "…"}</h2>
      <div className="text-caption text-muted-foreground">
        {type ? `${type} assembly` : "Assembly"} · from{" "}
        {ctx.source === "flow" ? "a Flow" : "a Playbook"}
      </div>
      {error && (
        <Alert severity="error" className="mt-2">
          Failed to load assembly information.
        </Alert>
      )}
    </div>
  );
};

export default AssemblyDetails;
